import { BaseObject } from './BaseObject';
import { SVGRenderer } from '../core/SVGRenderer';
import { Point2D } from '../types';

export class Arc extends BaseObject {
  public center: Point2D;
  public radius: number;
  public startAngleRad: number;
  public endAngleRad: number;
  public isConstruction: boolean;
  public sweepCW: boolean;
  public pathElem: SVGPathElement | null = null;
  public drawProgress: number = 0.0;

  constructor(
    renderer: SVGRenderer,
    center: Point2D,
    radius: number,
    startAngleRad: number,
    endAngleRad: number,
    isConstruction: boolean = true,
    sweepCW: boolean = false,
    id?: string
  ) {
    super(renderer, id);
    this.center = { ...center };
    this.radius = radius;
    this.startAngleRad = startAngleRad;
    this.endAngleRad = endAngleRad;
    this.isConstruction = isConstruction;
    this.sweepCW = sweepCW;
    this.color = isConstruction ? renderer.config.constructionColor : renderer.config.lineColor;
    this.strokeWidth = isConstruction ? 1.8 : 2.5;
    this.render();
  }

  public render(): SVGElement {
    // Interpolate endpoint for animation (always CCW/CW from start)
    const currentEndAngle = this.startAngleRad + (this.endAngleRad - this.startAngleRad) * this.drawProgress;
    const pathData = SVGRenderer.describeArcPath(this.center, this.radius, this.startAngleRad, currentEndAngle, this.sweepCW);

    this.pathElem = this.renderer.createElement('path', {
      id: this.id,
      d: pathData,
      fill: 'none',
      stroke: this.color,
      'stroke-width': this.strokeWidth,
      'stroke-linecap': 'round',
    });

    if (this.isConstruction) {
      this.renderer.layers.constructions.appendChild(this.pathElem);
    } else {
      this.renderer.layers.objects.appendChild(this.pathElem);
    }

    this.element = this.pathElem;
    return this.pathElem;
  }

  public setDrawProgress(progress: number): void {
    this.drawProgress = Math.max(0, Math.min(1, progress));
    this.update();
  }

  public update(): void {
    if (!this.pathElem) return;
    const currentEndAngle = this.startAngleRad + (this.endAngleRad - this.startAngleRad) * this.drawProgress;
    const pathData = SVGRenderer.describeArcPath(this.center, this.radius, this.startAngleRad, currentEndAngle, this.sweepCW);

    this.pathElem.setAttribute('d', pathData);
    this.pathElem.setAttribute('stroke', this.color);
  }
}
